import {styled, Box} from 'external/material'
import {range} from 'external/lodash'
import moment from 'external/moment'

import useCatalog from 'hooks/catalog'

import Day from './Day'

const groupWidth = 200
const groupStyle = {with: groupWidth, maxWidth: groupWidth, minWidth: groupWidth}

const StyledWeekGroup = styled(Box)(weekGroupStyles)

export default function WeekGroup(props) {
const {start, daySize, context, group, goToDay} = props 
const {subjects = {}} = useCatalog()
const days = range(7)
  .map(d => ({goToDay, group, context, daySize, date: moment(start).add(d, 'days')}))
  .map((props,i) => (<Day key={i} {...props}/>))

const subjectId = group.course.substring(0,2)
const subject = subjects[subjectId] || {}

const isRedundant = group.name.trim().toLowerCase() == group.courseName.trim().toLowerCase()

return (
  <StyledWeekGroup className="week">
    <div className="group" style={groupStyle}>
      <div className="color-band" style={{backgroundColor: subject.color}}/>
      <div className="title">
        {!isRedundant && (
        <div className="subject">
          {group.courseName}
        </div>)}
        <div className="name">
          {group.name}
        </div>
      </div>
    </div>
    {days}
  </StyledWeekGroup>
)
}

function weekGroupStyles() {
    return {
      "&.week": {
        display: 'flex',
        minHeight: '110px',
        borderBottom: 'solid 1px #e1eaee',
      },
      "& .group": {
        display: 'flex',
        "& .color-band": {
          flexShrink: 0,
          width: '5px'
        },
      "& .title": {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        "& > div": {
          padding: '4px 10px'
        }
      }
    }
  }
}
